import React, { useEffect, useState, useContext } from 'react';

import {
  FrontendImportRequest,
  IntegrateFlightAlignedResponse
} from '@tff/types/tff/integrate-flight-service';

import { apigeeEndpoint } from '../apis';
import { LoadingContext } from '../contexts/LoadingContextProvider';

export type UseReimport = {
  reimportResponse?: IntegrateFlightAlignedResponse;
  reimportStatus?: 'CONFIRMED' | 'FAILURE';
  reimportError?: unknown;
  setReimportRequest: (reimportRequest: FrontendImportRequest) => void;
};

export const useReimport = (): UseReimport => {
  const { showLoading, closeLoading } = useContext(LoadingContext);

  const [reimportStatus, setReimportStatus] = React.useState<'CONFIRMED' | 'FAILURE' | undefined>(undefined);
  const [reimportResponse, setReimportResponse] = React.useState<IntegrateFlightAlignedResponse | undefined>(undefined);
  const [reimportError, setReimportError] = React.useState<unknown>();
  const [reimportRequest, setReimportRequest] = useState<FrontendImportRequest | undefined>(undefined);

  useEffect(() => {
    const reimport = async (reimportRequest: FrontendImportRequest): Promise<void> => {
      try {
        showLoading('Importing the PNR');

        const response = await apigeeEndpoint.post<IntegrateFlightAlignedResponse>('reimport', reimportRequest);

        if (response.data.status === 'SUCCESS') {
          showLoading('Import was successful.\nRedirecting to Flightmanager');
          setReimportStatus('CONFIRMED');
          setReimportResponse(response.data);
        } else {
          setReimportStatus('FAILURE');
          setReimportError(response.data.error ?? Object.values(response.data));
          closeLoading();
        }
      } catch (error) {
        setReimportStatus('FAILURE');
        setReimportError(error);
        closeLoading();
      }
    };

    if (reimportRequest) {
      void reimport(reimportRequest);
    }
  }, [reimportRequest, showLoading, closeLoading]);

  return {
    setReimportRequest,
    reimportError,
    reimportResponse,
    reimportStatus,
  };
};
